module.exports = __webpack_public_path__ + "img/guy-1.e5f925c0.jpg";